
const messageTypes = {
    SUCCESS: "Operação realizada com sucesso!",
    ERROR: "Ocorreu um erro ao realizar essa operação",
    ERROR_LOAD: "Ocorreu um erro ao tentar carregar os dados",
    ERROR_SAVE: "Ocorreu um erro ao tentar salvar os dados",
    REQUIRED_FIELDS: "Por favor, preencha os campos obrigatórios",
    REQUIRED_FIELD: "Campo obrigatório",
    REGISTER_NOT_FOUNT: "Nenhum registro foi encontrado",
    SESSION_EXPIRED: "A sua sessão expirou. Por favor, faça o login novamente.",
};

export default messageTypes;